
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PDFNavigationProps {
  pageNumber: number;
  numPages: number;
  isTrainee: boolean;
  onPageChange: (newPage: number) => void;
}

export function PDFNavigation({
  pageNumber,
  numPages,
  isTrainee,
  onPageChange
}: PDFNavigationProps) {
  return (
    <div className="flex justify-between items-center py-2 px-4 border-b bg-white sticky top-0 z-10 shadow-sm">
      <div className="flex items-center space-x-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(pageNumber - 1)}
          disabled={pageNumber <= 1 || numPages === 0}
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <div className="text-sm">
          {numPages === 0 ? (
            <span className="text-gray-500">Loading PDF...</span>
          ) : (
            `Page ${pageNumber} of ${numPages}`
          )}
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(pageNumber + 1)}
          disabled={pageNumber >= numPages || numPages === 0}
        >
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
